import React, { useState, useEffect, useRef } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./App.css";
import Loader from "./Loader";
export default function Profile() {
  const fileInputRef = useRef();
  const [loading, setLoading] = useState(true);
  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger file input click
    }
  };
  const [height, setHeight] = useState(50);
  const [heightConversion, setHeightConversion] = useState("4'2'");
  const [heightType, setHeightType] = useState("inch");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [hMax, setHMax] = useState(100);
  const [hMin, setHMin] = useState(30);
  const [userId, setUserId] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(""); // For preview
  const [toUploadUrl, setToUploadUrl] = useState("");
  const [DOB, setDOB] = useState("2000-01-01");
  const [name, setName] = useState("");
  const [pic, setPic] = useState("");
  const [gender, setGender] = useState("male");
  const [weight, setWeight] = useState(50);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [uploadingFile, setUploadingFile] = useState(false);
  const [unitPref, setUnitPref] = useState("metric");
  const [formatPref, setFormatPref] = useState("mm/dd/yy");
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    //    setFile(selectedFile);
    // Generate preview URL
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewUrl(event.target.result); // Set preview URL
      };
      reader.readAsDataURL(selectedFile);
      handleUpload(selectedFile);
    } else {
      setPreviewUrl(""); // Clear preview if no file is selected
    }
  };
  const handleUpload = async (file) => {
    setUploadingFile(true);
    if (!file || !userId) {
      setError("No file selected or user ID is missing.");
      return;
    }
    const storageRef = ref(storage, `users/${userId}/${file.name}`); // Path in Firebase Storage
    try {
      const uploadTask = await uploadBytes(storageRef, file); // Upload file
      const url = await getDownloadURL(uploadTask.ref); // Get download URL
      updateUserPicture(url); // Save URL
      setError("");
      console.log("File uploaded successfully! URL:", url);
    } catch (err) {
      setError("Error uploading file: " + err.message);
    }
  };
  const updateUserPicture = async (url) => {
    const updatedFields = {
      imageUrl: url,
    };
    try {
      const userDocRef = doc(db, "users", userId); // 'users' is your collection name
      await updateDoc(userDocRef, updatedFields); // Updates only the provided fields
      setUploadingFile(false);
    } catch (error) {
      console.error("Error updating user profile:", error);
      setUploadingFile(false);
    }
  };
  const updateHeight = (input) => {
    setHeight(input);
    var string = "";
    if (heightType == "inch") {
      const feet = Math.floor(input / 12); // Calculate the whole feet
      const inches = input % 12; // Get the remaining inches
      string = feet + "'" + inches + "'";
    } else {
      const mtrs = Math.floor(input / 100); // Calculate the whole feet
      const cMtrs = input % 100; // Get the remaining inches
      string = mtrs + "." + cMtrs + "m";
    }
    setHeightConversion(string);
  };
  const changeHeightType = (value) => {
    setHeightType(value);
    if (value === "inch") {
      setHMax(100);
      setHMin(30);
    } else {
      setHMax(254);
      setHMin(76);
    }
  };
  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
    return age;
  };
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");
  const fetchUserData = async (userId) => {
    setLoading(true);
    try {
      const userDoc = doc(db, "users", userId); // 'users' is your Firestore collection name
      const docSnap = await getDoc(userDoc);
      if (docSnap.exists()) {
        setUserData(docSnap.data()); // Set user data
        var UD = docSnap.data();
        if (UD.age && UD.age != null) {
          setName(UD.firstName + " " + UD.lastName);
          setGender(UD.gender);
          setHeight(UD.height);
          setHeightType(UD.heightUnit);
          updateHeight(UD.height);
          setWeight(UD.weight);
          setDOB(formatDate(UD.dateOfBirth));
          setPreviewUrl(UD.imageUrl);
          setToUploadUrl(UD.imageUrl);
          setUnitPref(UD.unitPref ? UD.unitPref : "metric");
          setFormatPref(UD.formatPref ? UD.formatPref : "mmddyy");
        }
        setError("");
        setLoading(false);
      } else {
        setError("No user found with the provided ID.");
        setLoading(false);
      }
    } catch (err) {
      setError("Error fetching user data: " + err.message);
      setLoading(false);
    }
  };
  const formatDate = (inputDate) => {
    const date = new Date(inputDate); // Parse the input date string
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const updateUserProfile = async () => {
    setLoading(true);
    const updatedFields = {
      gender: gender,
      height: parseInt(height),
      heightUnit: heightType,
      weight: parseInt(weight),
      weightUnit: weightUnit,
      dateOfBirth: DOB + "T00:00:00.000",
      age: parseInt(calculateAge(DOB)),
      unitPref: unitPref,
      formatPref: formatPref,
    };
    try {
      const userDocRef = doc(db, "users", userId); // 'users' is your collection name
      await updateDoc(userDocRef, updatedFields); // Updates only the provided fields
      global.enableOtherPages();
      setLoading(false);
    } catch (error) {
      console.error("Error updating user profile:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    var localdata = localStorage.getItem("USERDATA");
    localdata = JSON.parse(localdata);
    var localId = localdata.localId;
    setUserId(localId);
    if (localId) {
      fetchUserData(localId);
    }
  }, [userId]);
  return (
    <div className="section profile">
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
        }}
      >
        <Loader loading={loading}></Loader>
        <div className="mainHeading">
          <i
            className="fa-regular fa-circle-user"
            style={{
              fontSize: 16,
              marginTop: -3,
            }}
          ></i>
          &nbsp;&nbsp;Profile
        </div>
       
        <div
          style={{
            marginTop: 20,
            textAlign: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
            onClick={() => {
              handleButtonClick();
            }}
          >
            <span className="badge bg-success">
              <i
                className="fa-solid fa-pencil"
                style={{
                  fontSize: 8,
                }}
              ></i>
              &nbsp;&nbsp;Edit
            </span>
          </div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <div className="circle">
              <div
                className="circle"
                style={{
                  width: 90,
                  height: 90,
                }}
              >
                <div
                  className="profileImageGreen"
                  style={{
                    backgroundImage:
                      previewUrl != "" ? `url(${previewUrl})` : "",
                    height: 80,
                    width: 80,
                    borderRadius: "100%",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  {uploadingFile ? (
                    <>
                      <div
                        className=""
                        style={{
                          backgroundColor: "rgba(0,0,0,0.7)",
                          height: 80,
                          width: 80,
                          borderRadius: "100%",
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                        }}
                      >
                        <i className="fa-solid fa-circle-notch fa-spin"></i>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*"
              style={{
                display: "none",
              }}
              onChange={handleFileChange}
            />
          </div>
          <br />
          <strong>{name}</strong>
        </div>
        <br />
        <br />
        <div
          className="glowBox"
          style={{
            padding: 20,
          }}
        >
          <div className="subHeading">Gender</div>
          <br />
          <div
            class="btn-group"
            style={{
              width: "100%",
            }}
          >
            <button
              type="button"
              className={
                gender == "male"
                  ? "btn btn-primary gradColor"
                  : "btn btn-light glowBox"
              }
              style={{
                width: "50%",
              }}
              onClick={() => setGender("male")}
            >
              Male
            </button>
            <button
              type="button"
              className={
                gender == "female"
                  ? "btn btn-primary gradColor"
                  : "btn btn-primary glowBox"
              }
              style={{
                width: "50%",
              }}
              onClick={() => setGender("female")}
            >
              Female
            </button>
          </div>
          <div
            className="subHeading"
            style={{
              marginTop: 40,
            }}
          >
            Height
          </div>
          <span
            style={{
              fontSize: 20,
              fontWeight: "bold",
            }}
          >
            {heightConversion}
          </span>
          <div
            style={{
              float: "right",
            }}
          >
            <span
              className={
                heightType == "meter"
                  ? "badge bg-light gradColor"
                  : "badge bg-light glowBox"
              }
              onClick={() => {
                changeHeightType("meter");
              }}
              style={{}}
            >
              Meter
            </span>
            &nbsp; &nbsp;
            <span
              className={
                heightType == "inch"
                  ? "badge bg-light gradColor"
                  : "badge bg-light glowBox"
              }
              onClick={() => {
                changeHeightType("inch");
              }}
              style={{}}
            >
              Feet
            </span>
          </div>
          <br />
          <input
            type="range"
            min={hMin}
            max={hMax}
            onInput={(e) => {
              updateHeight(e.target.value);
            }}
            style={{
              width: "100%",
            }}
            value={height}
          />
          <div
            className="subHeading"
            style={{
              marginTop: 30,
            }}
          >
            Weight
          </div>
          <div
            style={{
              float: "right",
            }}
          >
            <span
              className={
                weightUnit == "kg"
                  ? "badge bg-light gradColor"
                  : "badge bg-light glowBox"
              }
              onClick={() => {
                setWeightUnit("kg");
              }}
              style={{}}
            >
              Kg
            </span>
            &nbsp; &nbsp;
            <span
              className={
                weightUnit == "pound"
                  ? "badge bg-light gradColor"
                  : "badge bg-light glowBox"
              }
              onClick={() => {
                setWeightUnit("pound");
              }}
              style={{}}
            >
              Pound
            </span>
          </div>
          <input
            className="input"
            style={{
              background: "transparent",
              fontSize: 20,
              outline: "none",
              padding: 0,
            }}
            onChange={(e) => setWeight(e.target.value)}
            placeholder="Enter Weight"
            value={weight}
          />
          <div
            className="subHeading"
            style={{
              marginTop: 30,
            }}
          >
            Date Of Birth
          </div>
          <input
            className="input"
            type="date"
            value={DOB}
            style={{
              background: "transparent",
              fontSize: 20,
              outline: "none",
              padding: 0,
            }}
            onChange={(e) => {
              setDOB(e.target.value);
              console.log(e.target.value);
            }}
            placeholder=""
          />
        </div>
        <br />
        <div
          className="glowBox"
          style={{
            padding: 20,
          }}
        >
          <div className="subHeading">App Preferences</div>
          <br />
          <select
            className="input"
            value={unitPref}
            onChange={(e) => setUnitPref(e.target.value)}
          >
            <option value="metric">Metric</option>
            <option value="imperial">Imperial</option>
          </select>
          <br />
          <br />
          <select
            className="input"
            value={formatPref}
            onChange={(e) => setFormatPref(e.target.value)}
          >
            <option value="mmddyy">mm/dd/yy</option>
            <option value="ddmmyy">dd/mm/yy</option>
          </select>
          <br />
          <br />
        </div>
        <br />
        <button
          style={{}}
          className="btn btn-sm btn-success gradColor"
          onClick={() => {
            updateUserProfile();
          }}
        >
          Save Profile
        </button>
        <br />
        <br />
        <br />
        <button
          style={{
            opacity: "0.5",
          }}
          className="btn btn-sm btn-light btn-danger"
          onClick={() => {
            console.log('Logout From 5');
            global.logoutNow();
          }}
        >
          Logout
        </button>
      </div>
      <div className="spacer"></div>
    </div>
  );
}
